const UiMarquee = class extends HTMLElement {
  items: HTMLElement | null;

  connectedCallback() {
    this.items = this.querySelector(".section-marquee-banner__items");
    if (!this.items) return;

    this.setOffset();

    const animContainer = this.querySelector(".section-marquee-banner__anim");

    for (let i = 0; i < 10; i++) {
      animContainer?.appendChild(this.items.cloneNode(true));
    }

    window.addEventListener("resize", this.setOffset.bind(this));
  }

  private setOffset() {
    const bounding = this.items?.getBoundingClientRect();
    const width = Math.round(bounding?.width ?? 0);
    this.style.setProperty("--offset", `-${width}px`);
  }
};

customElements.define("marquee-banner", UiMarquee);
